import $ from 'jquery'
import JsAlert from 'js-alert'

const main = () => {
    if(document.getElementById('page-about') === null) return
    $('.work__head').click(function(){
        $(this).next('.work__contents').slideToggle();
        $(this).toggleClass("open");
    });
}

export default main